var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M1.9 5.1v11.2c0 .4.3.7.7.7h7.9v.8c0 .4-.3.7-.7.7h-9c-.4 0-.7-.3-.7-.7v-12c0-.4.3-.7.7-.7h1.1zM9 .9c.5 0 .8.4.8.8v3.6c0 .5.4.8.8.8H14c.5 0 .8.4.8.8v8c.2.6-.2 1-.7 1h-10c-.5 0-.8-.4-.8-.8V1.7c0-.5.4-.8.8-.8H9zm2.8.1l3.3 3.5c.2.2 0 .6-.3.6h-3.3c-.2 0-.3-.2-.3-.3V1.2c0-.3.4-.4.6-.2z","fill":"currentColor","fill-rule":"nonzero"}})
}
var staticRenderFns = []

export { render, staticRenderFns }